import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import { AD } from "../../../constants/itemTypes"
import { PROGRAM_ADS_ITEMS } from "../../../constants/state"
import getData from "../../../functions/getData"
import ListItemWithMovieContainer from "./ListItemWithMovieContainer"

const mapStateToProps = (state, ownProps) => ({
    itemData:  getData(state, [PROGRAM_ADS_ITEMS, ownProps.itemId])
})

const ListItemDataAdContainer = ({
    itemId,
    itemData,
    additionalClass =  false,
    isSelected = false,
    pathnameEdit = false,
    onDeleteItem = false
}) => <ListItemWithMovieContainer         
    itemType={AD}
    itemData={itemData}
    additionalClass={additionalClass}
    isSelected={isSelected}
    pathnameEdit={pathnameEdit}
    onDelete={() => onDeleteItem(itemId)}
/>

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(ListItemDataAdContainer)